// Extrae el "message" que devuelve el back en errores de RTK Query
// (FetchBaseQueryError) para mostrarlo tal cual al usuario.
export const getApiErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (typeof error === 'object' && error !== null) {
    const err = error as {
      data?: { message?: string | string[] } | string;
      status?: number | string;
    };

    if (typeof err.data === 'object' && err.data?.message) {
      const message = err.data.message;
      return Array.isArray(message) ? message.join(', ') : message;
    }

    if (typeof err.data === 'string' && err.data.trim() !== '') {
      return err.data;
    }
  }

  return fallback;
};
